
// Animation initialization utilities

export const initWowAnimations = () => {
  if (typeof window !== 'undefined' && (window as any).WOW) {
    try {
      console.log("Initializing WOW animations...");
      const wow = new (window as any).WOW({
        boxClass: 'wow',
        animateClass: 'animated',
        offset: 0,
        mobile: true,
        live: true,
        callback: function() {}, // Empty callback to prevent default
        scrollContainer: null // Optional scroll container selector
      });
      wow.init();
      console.log("WOW animations initialized successfully");
      return wow;
    } catch (error) {
      console.error("Error initializing WOW animations:", error);
    }
  } else {
    console.warn("WOW not available yet");
  }
  return null;
};

// Functions related to splash screen and visual effects
export const handleSplashScreen = () => {
  console.log("Handling splash screen");
  document.body.classList.add("no-scroll");
  
  // Use requestAnimationFrame for better timing with browser paint cycles
  requestAnimationFrame(() => {
    const splashElement = document.getElementById("try");
    if (splashElement) {
      splashElement.style.filter = "blur(0)";
      console.log("Removing splash blur");
    }
    
    // Cascade animations with requestAnimationFrame
    setTimeout(() => {
      requestAnimationFrame(() => {
        const splashElement = document.getElementById("splash");
        if (splashElement) {
          splashElement.style.opacity = "0";
          console.log("Setting splash opacity to 0");
          
          // Add transform for better performance
          splashElement.style.transform = "translateY(5%)";
          splashElement.style.transition = "opacity 0.5s ease-out, transform 0.5s ease-out";
        }
      });
    }, 1300); // Slightly reduced from 1500ms
    
    setTimeout(() => {
      const splashElement = document.getElementById("splash");
      if (splashElement) {
        splashElement.style.display = "none";
        console.log("Hiding splash screen");
      }
      document.body.classList.remove("no-scroll");
    }, 1800); // Reduced from 2000ms
  });
};
